<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">


        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>

      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">

            <el-col :span="5">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="16">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height"

          >

            <el-table-column
              label="Hesap Adı"
              prop="HesapAdi">
            </el-table-column>
            <el-table-column
              label="OrderId"
              prop="OrderId"
              width="200">
            </el-table-column>
            <el-table-column
              label="Mesaj"
              prop="Mesaj"
              width="200">
            </el-table-column>
            <el-table-column
              label="Tahsil"
              prop="Tahsil"
              width="200">
            </el-table-column>
            <el-table-column
              label="Firma"
              prop="Firma"
              width="200">
            </el-table-column>
            <el-table-column
              label="Araci"
              prop="Araci"
              width="200">
            </el-table-column>
            <el-table-column
              label="Kar"
              prop="Kar"
              width="200">
            </el-table-column>

          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import Yukleniyor from "../../components/Doc/Yukleniyor";

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));


export default {
  components: {Yukleniyor},
  data() {
    return {
      Height: 0,
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Sipay Havale Raporu',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Tarih: [],
        Pos_id: null,
        Durum: "1"
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
      },
      MakbuzDetayModal: false,
      tableData: [],
      ExcelData: [],
      tableDisplay: false,

    }
  },
  methods: {

    Excel(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 108},
        {wch: 10},
        {wch: 30},
        {wch: 10},
        {wch: 20},
        {wch: 20},
        {wch: 20},
        {wch: 100},
      ];

      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };
      XLSX.utils.book_append_sheet(wb, ws, this.DefterTur);
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");
    },
    Yazdir() {
      window.print();
    },

    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: '_a/sipaydetay'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.tableData = response.tableData;

                this.ExcelData = response.ExcelData;

                if (this.tableData)
                  this.tableDisplay = true;
                else
                  this.$message.error("Kayıt Bulunamadı");

                this.Height = window.innerHeight - 220;
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },


  },
  created() {

    var Gun = new Date();
    //this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    //this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Form.Tarih[0] = new Date();
    this.Form.Tarih[1] = new Date();
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/_a/SipayDetay.vue